"use client";

import type * as React from "react";

import { cn } from "../lib";
import {
	CIRCULAR_FIELD_EXP_DISK_CLASS,
	CIRCULAR_FIELD_WELL_CLASS,
	MENU_RADIO_EXP_DISK_CLASS,
	MENU_RADIO_OUTER_CLASS,
	MENU_RADIO_WELL_CLASS,
} from "../lib/circular-field-control-styles";

/**
 * Recessed inner well for 22px circular field controls (checkbox / radio).
 * Use `relative` when layering indicators (e.g. checkbox indeterminate overlay).
 */
export function CircularFieldControlWell({
	className,
	relative: relativeWell,
	...props
}: React.ComponentPropsWithoutRef<"span"> & {
	relative?: boolean;
}) {
	return (
		<span
			className={cn(
				relativeWell && "relative",
				CIRCULAR_FIELD_WELL_CLASS,
				className,
			)}
			{...props}
		/>
	);
}

/**
 * EXP gradient disk — checkbox places icons inside; radio leaves empty (tick suppressed).
 */
export function CircularFieldExpDisk({
	className,
	children,
	...props
}: React.ComponentPropsWithoutRef<"span">) {
	return (
		<span
			className={cn(CIRCULAR_FIELD_EXP_DISK_CLASS, className)}
			{...props}
		>
			{children}
		</span>
	);
}

/**
 * Menu-scale selected radio: same structure as checkbox but no tick (empty gradient disk).
 */
export function MenuCircularRadioIndicator({
	className,
	...props
}: React.ComponentPropsWithoutRef<"span">) {
	return (
		<span
			className={cn(MENU_RADIO_OUTER_CLASS, className)}
			aria-hidden
			{...props}
		>
			<span className={MENU_RADIO_WELL_CLASS}>
				<span className={MENU_RADIO_EXP_DISK_CLASS} />
			</span>
		</span>
	);
}
